import * as actionType from "./actions/assetsCategoryActions";

const initialState = {
  list: [],
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
  isSubCatCreate: false,
  isSubCatList: true,
  isSubCatEdit: false,
};

export default function assetsCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.GET_ASSETS_CATEGORY_LIST:
      return {
        ...state,
        loading: false,
        modalOpen: false,
        isSubCatList: true,
        isSubCatEdit: false,
        isSubCatCreate: false,
        message: "",
        AssetsCategoryDetail: action.payload,
      };
    case actionType.ASSETS_CATEGORY_API_START:
      return {
        ...state,
        loading: action.payload.loading,
        message: action.payload.message,
        modalOpen: action.payload.modalOpen,
        apiStatus: action.payload.apiStatus,
      };
    case actionType.GET_SELECTED_ASSETS_CATEGORY_LIST:
      return { ...state, SelectedAssetsCategoryDetail: action.payload };
    case actionType.SUB_CAT_EDIT:
      return { ...state, isSubCatEdit: action.payload, isSubCatList: false };
    case actionType.ADD_SUB_CAT:
      return {
        ...state,
        isSubCatEdit: false,
        isSubCatList: false,
        isSubCatCreate: action.payload,
      };
    case actionType.SUB_CAT_LIST:
      return {
        ...state,
        isSubCatEdit: false,
        isSubCatCreate: false,
        modalOpen: false,
        isSubCatList: action.payload,
      };

    case actionType.MAIN_CATEGORY_EDIT:
      return {
        ...state,
        mainCategoryEdit: action.payload.isEdit,
        mainCategoryEditRecord: action.payload.data,
      };
    case actionType.SUB_CATEGORY_EDIT:
      return {
        ...state,
        subCategoryEdit: action.payload.isEdit,
        subCategoryEditRecord: action.payload.data,
      };

    default:
      return state;
  }
}
